import { useState, useContext } from 'react'
import { useMutation } from "@apollo/client";
import { useToast } from "@chakra-ui/react";
import { UPGRADE_TO_PRO } from '../../graphql/mutations';
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';
import {edshopBuilderUrl} from"../../config"

export const usePricingPlan = () => {
  const { user, publisher } = useContext(PublisherAndUserContext);
  const [isYearly, setIsYearly] = useState(publisher?.subscriptionInfo?.frequency === "year" ? true : false);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [checkoutToPro] = useMutation(UPGRADE_TO_PRO, {
    onCompleted: (data) => {
        window.open(data.edshopifyCheckoutForProAccount.url, "_self")
    },
    onError: () => {
      toast({
        position: "top-right",
        title: "Something went wrong. Please try again after sometime.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    },
  });
  const plans = [
    {
      name: 'Free',
      monthlyPrice: 0,
      yearlyPrice: 0,
      features: [
        { label: '5 Course Creation', available: true },
        { label: '5 Book Creation', available: true },
        { label: '5 EdDoc Creation', available: true },
        { label: '5 Catalog Creation', available: true },
        { label: '10 Resource Upload', available: true },
      ],
    },
    {
      name: 'Pro',
      monthlyPrice: 49.99,
      yearlyPrice: 499.99,
      buttonText: 'Upgrade',
      features: [
        { label: 'Unlimited Course Creation', available: true },
        { label: 'Unlimited Book Creation', available: true },
        { label: 'Unlimited EdDoc Creation', available: true },
        { label: 'Unlimited Catalog Creation', available: true },
        { label: 'Unlimited Resource Upload', available: true },
        { label: 'Invite Staff To Collaborate For Course/Book Creation', available: true },
      ],
    },
  ];

  const upgradeToPro = () => {
    setLoading(true)
    checkoutToPro({
        variables: {
            data: {
                ...(publisher?.subscriptionInfo?.stripeCustomerId ? {customerId: publisher?.subscriptionInfo?.stripeCustomerId} : {}),
                successUrl: `${edshopBuilderUrl}/success`,
                cancelUrl: `${edshopBuilderUrl}/fail`,
                customer_email: user.email,
                metadata: JSON.stringify({publisherId: publisher.id, frequency: isYearly ? "year" : "month"})
            }
        }
    })
  }

  return {
    plans,
    isYearly,
    setIsYearly,
    upgradeToPro,
    loading,
    publisher
  }
}

